// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RateSummaryMutationVariables = Types.Exact<{
  updateDocumentSummaryId: Types.Scalars['ID']['input'];
  input: Types.UpdateDocumentSummaryInput;
}>;


export type RateSummaryMutation = { __typename?: 'Mutation', updateDocumentSummary: { __typename?: 'DocumentSummary', id: string, aiSummaryRating?: Types.DocumentSummaryAiSummaryRating | null, aiSummaryFeedback?: string | null, documentv2: { __typename?: 'Document', id: string } } };

export const Operations = {
  Mutation: {
    RateSummary: 'RateSummary' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const RateSummaryDocument = gql`
    mutation RateSummary($updateDocumentSummaryId: ID!, $input: UpdateDocumentSummaryInput!) {
  updateDocumentSummary(id: $updateDocumentSummaryId, input: $input) {
    id
    aiSummaryRating
    aiSummaryFeedback
    documentv2 {
      id
    }
  }
}
    `;
export type RateSummaryMutationFn = Apollo.MutationFunction<RateSummaryMutation, RateSummaryMutationVariables>;

/**
 * __useRateSummaryMutation__
 *
 * To run a mutation, you first call `useRateSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRateSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rateSummaryMutation, { data, loading, error }] = useRateSummaryMutation({
 *   variables: {
 *      updateDocumentSummaryId: // value for 'updateDocumentSummaryId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRateSummaryMutation(baseOptions?: Apollo.MutationHookOptions<RateSummaryMutation, RateSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RateSummaryMutation, RateSummaryMutationVariables>(RateSummaryDocument, options);
      }
export type RateSummaryMutationHookResult = ReturnType<typeof useRateSummaryMutation>;
export type RateSummaryMutationResult = Apollo.MutationResult<RateSummaryMutation>;
export type RateSummaryMutationOptions = Apollo.BaseMutationOptions<RateSummaryMutation, RateSummaryMutationVariables>;